import styled from "styled-components";
import { TextField, Button } from "@mui/material";
import { theme } from "@Styled";

export const StyledFormContainer = styled.form`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    padding: 1rem 0;
`;

export const StyledFieldGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`;

export const StyledLabel = styled.label`
    font-size: 0.875rem;
    font-weight: 600;
    color: ${theme.palette.common.black};
    margin-bottom: 0.25rem;
`;

export const StyledTextField = styled(TextField)`
    && {
        .MuiOutlinedInput-root {
            font-size: 0.95rem;
        }

        .MuiFormHelperText-root {
            font-size: 0.75rem;
            margin-top: 0.25rem;
            color: ${theme.palette.common.darkGray};
        }
    }
`;

export const StyledQuestionField = styled(StyledTextField)`
    && {
        .MuiOutlinedInput-input {
            padding: 0.875rem;
        }
    }
`;

export const StyledLabelField = styled(StyledTextField)`
    && {
        .MuiOutlinedInput-input {
            padding: 0.75rem;
        }
    }
`;

export const StyledPreviewContainer = styled.div`
    background: ${theme.palette.common.lightGray};
    border: 1px solid ${theme.palette.common.gray};
    border-radius: 0.5rem;
    padding: 1.5rem;
    margin: 0.5rem 0;
`;

export const StyledPreviewLabel = styled.h4`
    font-size: 0.875rem;
    font-weight: 600;
    color: ${theme.palette.common.darkGray};
    margin: 0 0 1rem 0;
    text-transform: uppercase;
    letter-spacing: 0.5px;
`;

export const StyledSliderContainer = styled.div`
    padding: 1rem 0;
    display: flex;
    align-items: center;
    gap: 1rem;
`;

export const StyledSliderWrapper = styled.div`
    flex: 1;

    .MuiSlider-root {
        color: ${theme.palette.common.tbCyan};
    }

    .MuiSlider-mark {
        height: 0.375rem;
        background-color: ${theme.palette.common.gray};
    }

    .MuiSlider-markActive {
        background-color: ${theme.palette.common.tbCyan};
    }
`;

export const StyledErrorMessage = styled.div`
    color: ${theme.palette.common.red};
    font-size: 0.875rem;
    padding: 0.75rem;
    background-color: #ffe0e0;
    border-radius: 0.375rem;
    border-left: 3px solid ${theme.palette.common.red};
    margin: 0.5rem 0;
`;

export const StyledActionsContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 0.75rem;
    margin-top: 1rem;
`;

export const StyledSubmitButton = styled(Button)`
    && {
        min-width: 120px;
        padding: 0.625rem 1.5rem;
        font-weight: 600;
        text-transform: uppercase;
        font-size: 0.875rem;
        letter-spacing: 0.5px;

        &:disabled {
            opacity: 0.6;
        }
    }
`;

export const StyledLoadingSpinner = styled.div`
    display: inline-block;
    width: 1rem;
    height: 1rem;
    border: 2px solid ${theme.palette.common.gray};
    border-top-color: ${theme.palette.common.tbCyan};
    border-radius: 50%;
    animation: spin 0.6s linear infinite;

    @keyframes spin {
        to {
            transform: rotate(360deg);
        }
    }
`;
